import React from "react";
import {
  getLastMessageSnippet,
  getLastMessageTimestamp,
} from "./utils/ChatUtils";

const OnlineChatList = ({ chats, activeChat, handleChatSelect }) => {
  return (
    <div className="chat-list">
      {chats.map((chatGroup, groupIndex) => (
        <div key={groupIndex} className="property-chat-section">
          {/* Group divider/header */}
          <div className="property-divider">
            <h3>{chatGroup.groupName}</h3>
          </div>

          {/* Group chats */}
          {chatGroup.users.map((chat, chatIndex) =>
            chat.isPlaceholder ? (
              // Display placeholder message when no contacts are available
              <div key={chatIndex} className="chat-item placeholder">
                <div className="chat-details">
                  <div className="chat-header">
                    <span className="chat-no-role-takers">
                      No contacts available
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              // Display normal chat item for contacts
              <div
                key={chatIndex}
                className={`chat-item ${
                  activeChat === chat.userId ? "active" : ""
                }`}
                onClick={() => {
                  console.log("Chat selected:", chat);
                  handleChatSelect(chat.user, chat.userId);
                }}
              >
                <div className="profile-picture">
                  {chat.profilePicture ? (
                    <img src={chat.profilePicture} alt={chat.user} />
                  ) : (
                    <div className="default-profile-picture"></div>
                  )}
                </div>
                <div className="chat-details">
                  <div className="chat-header">
                    <span className="chat-user">{chat.user}</span>
                    {chat.role && (
                      <span
                        className={`chat-role role-${chat.role
                          .toLowerCase()
                          .replace(/\s+/g, "-")}`}
                      >
                        {chat.role}
                      </span>
                    )}
                  </div>
                  <div className="chat-snippet">
                    {getLastMessageSnippet(chat.messages)}
                  </div>
                  <span className="last-message-timestamp">
                    {getLastMessageTimestamp(chat.messages)}
                  </span>
                </div>
              </div>
            )
          )}
        </div>
      ))}
    </div>
  );
};

export default OnlineChatList;
